/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Lv Zhuolin
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: Lv Zhuolin
 * @Description:
 * @FilePath: /desktop/src/store/modules/union.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
    getUnionMemberData,
    editUnionMemberStatus,
    downloadUnionMemberData,
    asyncUploadUnionMember,
    getUnionMemberManagementData,
    downloadUnionMemberManagementData
  } from "@/service/unionService";
  const newlyMarried = {
    state: {},
    mutations: {},
    getters: {},
    actions: {
      /**
       * 获取工会人员列表
       */
       getUnionMemberData(store, info) {
        return new Promise((resolve, reject) => {
            getUnionMemberData(info)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 改变人员的状态
       * @param {*} store
       * @param {*} data
       */
       editUnionMemberStatus(store, data) {
        return new Promise((resolve, reject) => {
            editUnionMemberStatus(data)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 下载Excel
       * @param {*} store
       * @param {*} id
       */
       downloadUnionMemberData(store, id) {
        return new Promise((resolve, reject) => {
            downloadUnionMemberData(id)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 批量上传
       * @param {*} store
       * @param {*} id
       */
      asyncUploadUnionMember(store, formdata) {
        return new Promise((resolve, reject) => {
          asyncUploadUnionMember(formdata)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 获取工会会员管理列表
       */
      getUnionMemberManagementData(store, info) {
        return new Promise((resolve, reject) => {
          getUnionMemberManagementData(info)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 下载工会会员管理的Excel
       * @param {*} store
       * @param {*} id
       */
       downloadUnionMemberManagementData(store) {
        return new Promise((resolve, reject) => {
          downloadUnionMemberManagementData()
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
    }
  };
  export default newlyMarried;
  


// WEBPACK FOOTER //
// ./src/store/modules/union.js